import { render, staticRenderFns } from "./ListIcon.vue?vue&type=template&id=5a970f68&scoped=true"
import script from "./ListIcon.vue?vue&type=script&lang=ts"
export * from "./ListIcon.vue?vue&type=script&lang=ts"
import style0 from "./ListIcon.vue?vue&type=style&index=0&id=5a970f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a970f68",
  null
  
)

export default component.exports